import axios from '.';

export default {
  fetchUserCards,
  createCard,
  verifyCard,
  deleteCard,
  uploadCardVerificationDocument,
  selectCardAsDefault,
};

async function fetchUserCards() {
  const response = await axios.get('/api/cards/list');
  return response.data;
}

async function createCard(data) {
  const response = await axios.post('/api/cards/create', {
    ...data,
    country_id: data.country_id.toString(),
  });
  return response.data;
}

async function verifyCard(data) {
  const response = await axios.post('/api/cards/verify', data);
  return response.data;
}

async function deleteCard(cardId) {
  const response = await axios.delete(`/api/cards/${cardId}`);
  return response.data;
}

async function uploadCardVerificationDocument(data, config) {
  let formData = new FormData();

  for (var key in data) {
    formData.append(key, data[key]);
  }
  const response = await axios.post('/api/cards/verification_document', formData, config)
  return response.data;
}

async function selectCardAsDefault(cardId) {
  const response = await axios.post(`/api/cards/make_default/${cardId}`);
  return response.data;
}
